import { cva, type VariantProps } from "class-variance-authority";
import {
  STATUS_VARIANT_CLASS,
  type StatusVariant,
} from "@quovy/field-types/internal/status-variant-tokens";

const VARIANT_CLASS: Record<StatusVariant, string> = {
  ...STATUS_VARIANT_CLASS,
  // Literals (not the imported strings) so this file — which Tailwind and
  // Vite both watch — is the one that emits the dark: yellow utilities.
  // Keep in sync with `STATUS_VARIANT_CLASS.warning` / `.queued`.
  warning: "bg-yellow-100 dark:bg-yellow-950/50 text-yellow-800 dark:text-yellow-200",
  queued: "bg-yellow-100 dark:bg-yellow-950/50 text-yellow-800 dark:text-yellow-200",
};

export const statusBadgeVariants = cva("flex items-center gap-1", {
  variants: {
    variant: VARIANT_CLASS,
  },
});

export type { StatusVariant };

// Sanity check at build time: the cva variant keys come from the shared token map.
type _AssertVariantParity =
  StatusVariant extends NonNullable<VariantProps<typeof statusBadgeVariants>["variant"]>
    ? NonNullable<VariantProps<typeof statusBadgeVariants>["variant"]> extends StatusVariant
      ? true
      : never
    : never;
